import React, { useState, useEffect } from 'react';
import 'react-time-picker/dist/TimePicker.css';
import TimePicker from 'react-time-picker';
import './TimePickerGrid.scss';




export function TimePickerGrid({ row, column, onRowChange }) {
  const rawTime = row?.[column.key];

  // Initialize time value
  let initialTime = "00:00:00";
  if (typeof rawTime === 'string' && /^\d{2}:\d{2}:\d{2}$/.test(rawTime)) {
    initialTime = rawTime;
  }




  const [timeValue, setTimeValue] = useState(initialTime);
  const handleRowChange = typeof onRowChange === 'function' ? onRowChange : () => {};

  // Sync timeValue with rawTime when row or column.key changes
  useEffect(() => {
    let newTime = "00:00:00";
    if (typeof rawTime === 'string' && /^\d{2}:\d{2}:\d{2}$/.test(rawTime)) {
      newTime = rawTime;
    }
    setTimeValue(newTime);
  }, [rawTime, column.key]);

  const handleTimeChange = (newTime) => {
    if (!newTime) {
      setTimeValue("00:00:00");
      handleRowChange("00:00:00");
      return;
    }

    const [hours, minutes, seconds = 0] = newTime.split(':').map(num => parseInt(num, 10) || 0);
    const formatNumber = (num) => num.toString().padStart(2, '0');
    const validatedTime = `${formatNumber(hours)}:${formatNumber(minutes)}:${formatNumber(seconds)}`;
   
    setTimeValue(validatedTime);
    handleRowChange(validatedTime);
  };




  return (
    <TimePicker
      value={timeValue}
      hourPlaceholder="HH"
      minutePlaceholder="mm"
      secondPlaceholder="ss"
      maxDetail="second"
      onChange={handleTimeChange}
      disableClock={true}
      format="HH:mm:ss"
      clearIcon={null}
      clockIcon={null}
      isOpen={false}
      className="custom-timepicker"
    />
  );
}